import AxiosInstance from "./api";

export const DetailedInventoryLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/detailed-inventory-ledgers/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/detailed-inventory-ledgers/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/detailed-inventory-ledgers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/detailed-inventory-ledgers/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/detailed-inventory-ledgers/" + id);
  },
};
